<template>
  <div>
    <h4>Összes tartozás</h4>
    <div v-loading="loading">{{ sum | currency }}</div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        loading: false,
        sum: 0
      };
    },
    methods: {
      async load() {
        this.loading = true;
        try {
          this.sum = await axios.get('api/balances/sum');
        } catch (e) {
        }
        this.loading = false;
      }
    },
    async mounted() {
      await this.load();
    }
  };
</script>
